/*
  La Matcha — footer behaviour.

    <newsletter-form>  checks the email address and the consent box before the form is sent
    <footer-menus>     menu columns: accordions below 750px, always open from 750px

  Without JavaScript the browser validates the form and every menu column stays open.
*/
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* ---------- <newsletter-form> ----------
     Wraps the customer form. Children: [data-newsletter-email], [data-newsletter-consent] (optional),
     [data-newsletter-error] with data-email-error and data-consent-error texts. */
  class NewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.email = this.querySelector('[data-newsletter-email]');
      this.consent = this.querySelector('[data-newsletter-consent]');
      this.error = this.querySelector('[data-newsletter-error]');
      if (!this.form || !this.email || this.bound) return;
      this.bound = true;
      this.form.noValidate = true;

      this.form.addEventListener('submit', (event) => {
        this.clear();
        if (!EMAIL.test(this.email.value.trim())) {
          event.preventDefault();
          this.fail(this.email, this.error && this.error.dataset.emailError);
        } else if (this.consent && !this.consent.checked) {
          event.preventDefault();
          this.fail(this.consent, this.error && this.error.dataset.consentError);
        }
      });
      this.email.addEventListener('input', () => this.clear());
      if (this.consent) this.consent.addEventListener('change', () => this.clear());
    }

    fail(field, message) {
      field.setAttribute('aria-invalid', 'true');
      if (this.error) this.error.textContent = message || '';
      field.focus();
    }

    clear() {
      this.email.removeAttribute('aria-invalid');
      if (this.consent) this.consent.removeAttribute('aria-invalid');
      if (this.error) this.error.textContent = '';
    }
  }

  /* ---------- <footer-menus> ----------
     Children: <details> columns, all rendered open. Below 750px they start closed and
     opening one closes the others; from 750px they are all open and cannot be toggled. */
  class FooterMenus extends HTMLElement {
    connectedCallback() {
      this.columns = [...this.querySelectorAll(':scope > details')];
      if (!this.columns.length) return;

      if (!this.bound) {
        this.bound = true;
        this.addEventListener('click', (event) => {
          if (!mobile.matches && event.target.closest('summary')) event.preventDefault();
        });
        this.addEventListener(
          'toggle',
          (event) => {
            const column = event.target;
            if (!mobile.matches || !column.open) return;
            this.columns.forEach((other) => {
              if (other !== column) other.open = false;
            });
          },
          true
        );
      }

      this.sync = () => {
        this.columns.forEach((column) => {
          column.open = !mobile.matches;
          const summary = column.querySelector('summary');
          if (!summary) return;
          if (mobile.matches) summary.removeAttribute('tabindex');
          else summary.setAttribute('tabindex', '-1');
        });
      };
      mobile.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      if (this.sync) mobile.removeEventListener('change', this.sync);
    }
  }

  if (!customElements.get('newsletter-form')) customElements.define('newsletter-form', NewsletterForm);
  if (!customElements.get('footer-menus')) customElements.define('footer-menus', FooterMenus);
})();
